import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation, userSettingsStore } from '@pascal/pascal-core';
import {
  doBetStore,
  gameStore,
  inputValidationStore,
  manualBetStore,
  oddStore,
} from '../../../../store';
import { globalTranslationKeys } from '../../../../enums';
import { DoBetSection } from '../../../../components/common/bettingPart';

export const DoBetSectionWr = observer(({ betAmount, index, isLoaderActive, activeFreeBet, i }) => {
  const { Bet, CashOut, BetForNextRound, Cancel, FreeBets, MinOdd } = globalTranslationKeys;
  const isClosedDoBet = inputValidationStore.validationSections[index].isClosedDoBet;
  const t = useTranslation();
  const { isHalfCashOutOn } = userSettingsStore;
  const { isMaxWin, isFreeBetMaxWin } = oddStore;
  const {
    doBetSectionsData: {
      [i]: { isNextRoundBet, betId, isBetAccepted, isDisabled, freeBetId, isHalfCashOuted },
    },
    doBetSender,
    sendCashOut,
    handleBetForNextRound,
    setDisabledState,
    freeBetDisable,
    freeBetMinOdd,
  } = doBetStore;
  const { isBetsClosed, partnerWageringOdd, partnerWageringDisabled } = gameStore;
  const { betButtonDisable } = manualBetStore;

  const handleDoBetEvents = useCallback(
    (index, halfCashOut) => {
      if (!isBetAccepted && !isBetsClosed) {
        doBetSender(index);
      } else if (isBetAccepted) {
        sendCashOut(index, betId, null, halfCashOut);
      } else if (!isBetAccepted && isBetsClosed && !betButtonDisable) {
        handleBetForNextRound(index);
      }
      setDisabledState();
    },
    [isBetAccepted, isBetsClosed, betButtonDisable, inputValidationStore.validationSections]
  );
  const betBtnText = useMemo(
    () =>
      isBetAccepted || (!isBetsClosed && isNextRoundBet)
        ? CashOut
        : !isBetAccepted && isBetsClosed && !isNextRoundBet && !betButtonDisable
        ? BetForNextRound
        : !isBetAccepted && isNextRoundBet && isBetsClosed
        ? Cancel
        : activeFreeBet.id || freeBetId
        ? FreeBets
        : Bet,
    [isBetAccepted, isNextRoundBet, isBetsClosed, betButtonDisable, activeFreeBet]
  );
  const freeBetRemainingCount = betBtnText === FreeBets ? activeFreeBet.remainingCount : '';
  const additionalBtnInfo =
    (!isBetAccepted && activeFreeBet.minOdd && !activeFreeBet.isMinOddNull) ||
    (freeBetId && !activeFreeBet.isMinOddNull) ? (
      <p> {` ${t(MinOdd)} x${activeFreeBet.minOdd || freeBetMinOdd}`} </p>
    ) : partnerWageringOdd ? (
      <p> {` ${t(MinOdd)} x${partnerWageringOdd}`} </p>
    ) : null;
  const disabled =
    betButtonDisable ||
    (isBetAccepted && !isBetsClosed) ||
    (isBetAccepted && partnerWageringDisabled) ||
    (isBetAccepted && freeBetDisable && freeBetId) ||
    isDisabled
      ? 'disabled'
      : '';
  return (
    <DoBetSection
      handleDoBetEvents={handleDoBetEvents}
      index={index}
      isMaxWin={isMaxWin[index]}
      isFreeBetMaxWin={isFreeBetMaxWin[index]}
      betAmount={betAmount}
      betBtnText={betBtnText}
      disabled={disabled}
      isLoaderActive={isLoaderActive}
      isBetAccepted={isBetAccepted}
      isClosedDoBet={isClosedDoBet}
      additionalBtnInfo={additionalBtnInfo}
      isHalfCashOutOn={isHalfCashOutOn}
      isHalfCashOuted={isHalfCashOuted}
      freeBetRemainingCount={freeBetRemainingCount}
    />
  );
});
